import styled from "styled-components";

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding: 1rem 0;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};

  &:last-child {
    border: none;
    padding: 1rem 0 0;
  }
`;

export const DiscountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  padding: 1rem 0;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
`;

export const Paragraph = styled.p`
  margin: 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const Discount = styled(Paragraph)`
  color: ${({ theme }) => theme.checkoutStepsOffers?.green} !important;
`;

export const Strong = styled.strong`
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.688rem;
  text-align: end;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};

  &:last-child {
    margin: 0 0 0 0.5rem;
  }
`;

export const LittleLetters = styled.small`
  display: flex;
  align-items: center;

  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;
